import { useAutoneTranslation } from '@autone/translations';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../../atoms';
import { useAdvancedFiltersInternalContext } from '../contexts/advanced-filters-internal.context';

export const AdvancedFiltersConditionCombineMode = () => {
  const { common } = useAutoneTranslation();
  const { state, dispatch } = useAdvancedFiltersInternalContext();
  const { conditionCombineMode } = state;

  return (
    <Select
      value={conditionCombineMode}
      onValueChange={(val: 'and' | 'or') =>
        dispatch({ type: 'CHANGE_COMBINE_MODE', payload: { condition: val } })
      }
    >
      <SelectTrigger
        id="advanced-filter-condition"
        aria-label="Advanced filter condition"
        className="h-9 shadow-sm w-fit"
      >
        <div className="w-full text-start overflow-hidden text-ellipsis text-sm">
          <SelectValue />
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem className="text-sm" value="and">
          {common('advanced-filters.and')}
        </SelectItem>
        <SelectItem className="text-sm" value="or">
          {common('advanced-filters.or')}
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
